<template>
  <v-tabs
    v-model="value"
    :class="{
      'ai-tabs--rounded': props.type === 'rounded',
      'ai-tabs--square': props.type === 'square',
      'ai-tabs--default': props.type === 'default',
      'ai-tabs': props.type === '',
    }"
    class="ai-tabs"
    hide-slider
    fixed-tabs
    touchless
    v-bind="$attrs"
  >
    <v-tab
      class="ai-tabs__item"
      v-for="item in props.items"
      :key="item.value.toString()"
      :value="item.value"
      selected-class="ai-tabs__item--active"
    >
      <span>{{ item.label }}</span>
      <span class="ai-tabs__discount" v-if="item.discount">{{ item.discount }}</span>
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { TTabItem } from '@/types/TTabItem';

type TTabsType = 'rounded' | 'default' | 'square' | '';

const props = defineProps({
  modelValue: {
    type: [String, Boolean, Number] as PropType<string | boolean | number>,
    required: true,
  },
  type: {
    type: String as PropType<TTabsType>,
    required: false,
    default: 'default',
  },
  items: {
    type: Array as PropType<TTabItem[]>,
    required: false,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});
</script>

<style scoped lang="scss" src="./AiTabs.scss" />
